import { supabase } from "./supabaseClient";
import { compressImage } from "./Utility/mediaProcess";
import { buildCorrections } from "./Utility/Utilities";


export async function uploadMediaFile(file, questionId, itemIndex) {
    const isImage = file.type?.startsWith("image/");
    const isVideo = file.type?.startsWith("video/");

    let uploadBlob = file;
    if (isImage) {
        uploadBlob = await compressImage(file);
    }

    const ext = file.name?.split(".").pop() || (isImage ? "jpg" : "mp4");
    const folder = isVideo ? "videos" : "images";
    const path = `${folder}/${questionId}/${itemIndex}.${ext}`;

    const { data, error } = await supabase.storage
        .from("question-media")
        .upload(path, uploadBlob, {
            contentType: uploadBlob.type || file.type,
            upsert: true,
        });

    if (error) throw error;

    const { data: urlData } = supabase.storage
        .from("question-media")
        .getPublicUrl(path);

    return urlData.publicUrl;
}



export async function uploadAllQuestionMedia(questions) {
    const copy = questions.map(q => ({
        ...q,
        items: q.items.map(item => ({
            ...item,
            res: { ...item.res },
        })),
    }));

    for (const question of copy) {
        const items = question.items || [];

        for (const item of items) {
            const isMedia = item.media === "image" || item.media === "video";
            if (!isMedia || !item.res?.local || !item.res?.url) continue;

            try {
                let file;
                if (item.res.url instanceof File || item.res.url instanceof Blob) {
                    file = item.res.url;
                } else {
                    const response = await fetch(item.res.url);
                    const blob = await response.blob();
                    file = new File([blob], `${item.ind}.${item.media === "video" ? "mp4" : "jpg"}`, {
                        type: blob.type,
                    });
                }

                const publicUrl = await uploadMediaFile(file, question.id, item.ind);
                item.res.url = publicUrl;
                item.res.local = false;
            } catch (err) {
                return {
                    success: false,
                    msg: `Question ${question.ind}, Item ${item.ind}: ${item.media} upload failed — ${err.message}`,
                };
            }
        }
    }

    return {
        success: true,
        msg: "All media uploaded",
        questions: copy,
    };
}

export function downloadData(payload) {
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "questions-data.txt";
    a.click();
    URL.revokeObjectURL(url);
}


export async function createTest(testData) {

  const { data, error } = await supabase
    .from("tests")
    .insert(testData)
    .select()
    .single();

  if (error) {
    return { success: false, msg: error.message };
  }

  return { success: true, testId: data.id, data };
}



export async function insertResources(rows) {

  const { data, error } = await supabase
    .from("resources")
    .insert(rows)
    .select();

  if (error) {
    return { success: false, msg: error.message };
  }

  return { success: true, count: rows.length, data };
}


/**
 * Insert all corrections in one batch call
 */
export async function createCorrections(questions) {
  const rows = buildCorrections(questions);

  const { error } = await supabase
    .from("corrections")
    .insert(rows);

  if (error) return { success: false, msg: error.message };
  return { success: true, count: rows.length };
}

